/***
 * @file:
 * @author: haoxianhuan
 * @Date: 2021-09-02 14:06:10
 */
import { Component, Input, OnInit } from '@angular/core';
import monitor from '../../monitor';

@Component({
  selector: 'dt-form-button',
  templateUrl: './form-button.component.html',
  styleUrls: ['./form-button.component.scss'],
})
export class FormButtonComponent implements OnInit {
  @Input() type = 'button';
  @Input() label = '';
  @Input() prop = '';
  @Input() disabled: boolean;
  @Input() buttonType = 'primary';
  @Input() associate: any;
  @Input() modelName: string;
  constructor() {}

  ngOnInit() {}
  handleClick() {
    monitor.emit("showModal", this.modelName , true, {associate: this.associate});
  }
}
